///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ('The Web Application Messaging Protocol').
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////
/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0,no-redeclare:0,
no-param-reassign:0,no-extra-semi:0,consistent-return:0,quote-props:0 */
/* global AUTOBAHN_DEBUG:true */
var util = require('../util.js');



function Factory (options) {
    var self = this;

    util.assert(typeof options.url !== 'undefined', 'options.url missing');
    util.assert(typeof options.url === 'string', 'options.url must be a string');

    self._options = options;
};


Factory.prototype.type = 'longpoll';


Factory.prototype.create = function () {

    var self = this;

    // the WAMP transport we create
    var transport = {};

    // these will get overridden by the WAMP session using this transport
    transport.onmessage = function () {};
    transport.onopen = function () {};
    transport.onclose = function () {};

    transport.info = {
        type: 'longpoll',
        url: null,
        protocol: 'wamp.2.json'
    };

    transport._run = function () {

        var is_closing = false;
        var request_timeout = self._options.request_timeout || 30000; // timeout here > than the 10s default in Crossbar.io

        // Transport Closing
        var closeConnection = function(code, reason, wasClean) {
            var details = { code: code, reason: reason, wasClean: wasClean };
            transport.onclose(details);
        };

        // Attempt to Connect First, allows ample room for the window to load properly
        setTimeout(function() {
            util.http_get_jsonp(self._options.url + '/api/connect?v=2&jsoncallback=%s', '%s', request_timeout).then(function (payload) {

                // Parse Connection Response
                var session_info = JSON.parse(payload);
                var session_id = typeof session_info === typeof [] && session_info.length > 1 && session_info[0] === 0 && session_info[1];
                var base_url = self._options.url;

                // Check Valid Session
                if (!session_id) {
                    is_closing = true;
                    closeConnection(1001, 'transport connect failure (Invalid session ID received)', false);
                    return;
                }

                // WebAPI URL
                transport.info.url = base_url;

                // Closing
                transport.close = function (/* code, reason */) {

                    if (is_closing) {
                        throw 'transport is already closing';
                    }

                    is_closing = true;
                    closeConnection(1000, 'transport closed', true);
                }

                // Sending Data
                transport.send = function (msg) {

                    if (is_closing) {
                        throw 'transport is closing or closed already';
                    }

                    var payload = JSON.stringify(msg);

                    util.http_post_json(base_url + '/api/send?sid=' + session_id, { message: payload }, request_timeout).then(
                        function () {
                            // OK, Message Sent
                        },

                        function () {
                            is_closing = true;
                            closeConnection(1001, 'transport send failure (HTTP/POST probably timed out)', false);
                        }
                    );
                };

                // Receiving Data
                function receive() {

                    util.http_get_jsonp(base_url + '/api/messages?sid=' + session_id + '&jsoncallback=%s', '%s', request_timeout).then(
                        function (payload) {
                            if (payload && payload.messages && payload.messages.length) {
                                for (var i = 0; i < payload.messages.length; i++) {
                                    transport.onmessage(JSON.parse(payload.messages[i]));
                                }
                            }

                            if (!is_closing) {
                                receive();
                            }
                        },
                        function () {
                            is_closing = true;
                            closeConnection(1001, 'transport receive failure (HTTP/GET probably timed out)', false);
                        }
                    );
                }

                // Start Receiving Data
                receive();

                // Announce Transport Opening
                transport.onopen();

            // Connection Error
            }, function () {
                is_closing = true;
                closeConnection(1001, 'transport open failure (HTTP/GET request failed or timed out)', false);
            });
        }, 60);
    }

    transport._run();
    return transport;
};

exports.Factory = Factory;



// WEBPACK FOOTER //
// ./src/lightweight-autobahn/src/transport/longpoll.js